module.exports = __webpack_public_path__ + "media/recipes/7-f40de4b5.png";